import * as ambassadorWixIdentityOauthV1RefreshToken from './identity-oauth-v1-refresh-token-oauth.http.js';
import * as ambassadorWixIdentityOauthV1RefreshTokenTypes from './identity-oauth-v1-refresh-token-oauth.types.js';
import * as ambassadorWixIdentityOauthV1RefreshTokenUniversalTypes from './identity-oauth-v1-refresh-token-oauth.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function token(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIdentityOauthV1RefreshTokenUniversalTypes.RawHttpRequest,
  ambassadorWixIdentityOauthV1RefreshTokenTypes.RawHttpRequest,
  ambassadorWixIdentityOauthV1RefreshTokenUniversalTypes.RawHttpResponse,
  ambassadorWixIdentityOauthV1RefreshTokenTypes.RawHttpResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityOauthV1RefreshToken.token(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/oauth/token',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function tokenInfo(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIdentityOauthV1RefreshTokenUniversalTypes.RawHttpRequest,
  ambassadorWixIdentityOauthV1RefreshTokenTypes.RawHttpRequest,
  ambassadorWixIdentityOauthV1RefreshTokenUniversalTypes.TokenInfoResponse,
  ambassadorWixIdentityOauthV1RefreshTokenTypes.TokenInfoResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityOauthV1RefreshToken.tokenInfo(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/oauth/token-info',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  RefreshToken as RefreshTokenOriginal,
  AuthorizeRequest as AuthorizeRequestOriginal,
  RawHttpResponse as RawHttpResponseOriginal,
  HeadersEntry as HeadersEntryOriginal,
  RawHttpRequest as RawHttpRequestOriginal,
  PathParametersEntry as PathParametersEntryOriginal,
  QueryParametersEntry as QueryParametersEntryOriginal,
  DeviceCodeRequest as DeviceCodeRequestOriginal,
  DeviceCodeResponse as DeviceCodeResponseOriginal,
  DeviceVerifyRequest as DeviceVerifyRequestOriginal,
  DeviceVerifyResponse as DeviceVerifyResponseOriginal,
  DeviceVerifyV2Request as DeviceVerifyV2RequestOriginal,
  DeviceVerifyV2Response as DeviceVerifyV2ResponseOriginal,
  InvalidateUserCodeRequest as InvalidateUserCodeRequestOriginal,
  InvalidateUserCodeResponse as InvalidateUserCodeResponseOriginal,
  RevokeRefreshTokenRequest as RevokeRefreshTokenRequestOriginal,
  RevokeRefreshTokenResponse as RevokeRefreshTokenResponseOriginal,
  TokenInfoResponse as TokenInfoResponseOriginal,
  SubjectType as SubjectTypeOriginal,
  SubjectTypeWithLiterals as SubjectTypeWithLiteralsOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  UserDeletedEvent as UserDeletedEventOriginal,
  UserBlockedEvent as UserBlockedEventOriginal,
  UserInfoRequest as UserInfoRequestOriginal,
  UserInfoResponse as UserInfoResponseOriginal,
} from './identity-oauth-v1-refresh-token-oauth.types.js';
